// Прогнозы «сильного режима»: результат симуляции фаз войны следующих
// противников раунда. Данные совещательные (как и все стратегическое состояние
// ботов): устаревший или отсутствующий прогноз деградирует к обычному поведению.

const predictionsByPlayerId = new Map();

export const setBotPredictions = (playerId, round, data) => {
  predictionsByPlayerId.set(playerId, {round, data});
};

/**
 * Прогноз игрока для раунда round или null (не считался/устарел).
 */
export const getBotPredictions = (playerId, round) => {
  const entry = predictionsByPlayerId.get(playerId);
  return entry && entry.round === round ? entry.data : null;
};

export const clearBotPredictions = () => {
  predictionsByPlayerId.clear();
};
